import { Children, React, useEffect, useLayoutEffect, useState } from "react";
import { Flex, Space, Splitter, Typography, Tag, Tabs, Image } from 'antd';
import {CloseOutlined} from '@ant-design/icons';
import TzolkinMain from './TzolkinMain';
import Logo from './Logo';
import MdText from "./MdText";
import maya from "./js/maya";
import KinShortDescription from "./components/KinShortDescription";
import SignTag from "./components/signTag";

const OneConnection = (props) => {
    var title = "";
    var conns = maya.getConnections(props.sign*1);
    var contype = "";
    var style = {fontSize: "1.1em"};
    switch(props.contype) {
      case 0:
        title = (
          <Typography.Text>
            <SignTag sign={props.sign} locale={props.locale}/>
            <Tag color="green" style={style}>{props.locale.support}</Tag>
            <SignTag sign={conns[0]} locale={props.locale}/>
            </Typography.Text>);
        contype = "_support_to_";
        break;
      case 1:
        title = (
          <Typography.Text>
            <SignTag sign={conns[1]} locale={props.locale}/>
            <Tag color="green" style={style}>{props.locale.support}</Tag>
            <SignTag sign={props.sign} locale={props.locale}/>
            </Typography.Text>);
        contype = "_support_from_";
        break;
      case 2:
        title = (
          <Typography.Text>
            <SignTag sign={props.sign} locale={props.locale}/>
            <Tag color="blue" style={style}>{props.locale.control}</Tag>
            <SignTag sign={conns[2]} locale={props.locale}/>
            </Typography.Text>);
        contype = "_control_to_";
        break;
      case 3:
        title = (
          <Typography.Text>
            <SignTag sign={conns[3]} locale={props.locale}/>
            <Tag color="blue" style={style}>{props.locale.control}</Tag>
            <SignTag sign={props.sign} locale={props.locale}/>
            </Typography.Text>);
        contype = "_control_from_";
        break;
      case 4:
        title = (
          <Typography.Text>
            <SignTag sign={props.sign} locale={props.locale}/>
            <Tag color="red" style={style}>{props.locale.passion}</Tag>
            <SignTag sign={conns[4]} locale={props.locale}/>
            </Typography.Text>);
        contype = "_passion_";
        break;
      case 5:
        title = (
          <Typography.Text>
            <SignTag sign={props.sign} locale={props.locale}/>
            <Tag color="pink" style={style}>{props.locale.friend}</Tag>
            <SignTag sign={conns[5]} locale={props.locale}/>
            </Typography.Text>);
        contype = "_friend_";
        break;
      case 6:
        title = (
          <Typography.Text>
            <SignTag sign={props.sign} locale={props.locale}/>
            <Tag color="yellow" style={style}>{props.locale.secret}</Tag>
            <SignTag sign={conns[6]} locale={props.locale}/>
            </Typography.Text>);
        contype = "_secret_";
        break;
    }
    return (<Typography.Paragraph>
      {title}
      <Typography.Paragraph>
        <MdText url={"/md/connection/"+props.lang+"/sign_"+props.sign+contype+conns[props.contype*1]+".md"}/>
      </Typography.Paragraph>
      </Typography.Paragraph>)
}


const TzolkinCharacter = (props) => {
  var tabs = [
      {
        key: 'character_desc'+props.sign,
        label: props.locale.character,
        children: (
          <Typography.Paragraph>
            <Image src={"/img/photo"+props.sign+".jpg"}/>
            <MdText url={"/md/character/"+props.lang+"/character_"+props.sign+".md"}/>
            </Typography.Paragraph>
        )
      },
      {
        key: 'character_meaning'+props.sign,
        label: props.locale.meaning_symbol,
        children: (
          <Typography.Paragraph>
            <Image src={"/img/"+props.sign+".svg"} width={"50%"}/>
            <MdText url={"/md/character/"+props.lang+"/symbol_"+props.sign+".md"}/>
            </Typography.Paragraph>
        )
      },
      {
        key: 'character_connections'+props.sign,
        label: props.locale.connections,
        children: [
          (<OneConnection sign={props.sign} contype={0} locale={props.locale} selectSign={props.selectSign} lang={props.lang}/>),
          (<OneConnection sign={props.sign} contype={1} locale={props.locale} selectSign={props.selectSign} lang={props.lang}/>),
          (<OneConnection sign={props.sign} contype={2} locale={props.locale} selectSign={props.selectSign} lang={props.lang}/>),
          (<OneConnection sign={props.sign} contype={3} locale={props.locale} selectSign={props.selectSign} lang={props.lang}/>),
          (<OneConnection sign={props.sign} contype={4} locale={props.locale} selectSign={props.selectSign} lang={props.lang}/>),
          (<OneConnection sign={props.sign} contype={5} locale={props.locale} selectSign={props.selectSign} lang={props.lang}/>),
          (<OneConnection sign={props.sign} contype={6} locale={props.locale} selectSign={props.selectSign} lang={props.lang}/>),
        ]
      }
    ];
  return (
    <Tabs
        items={tabs}
    />
  );
}

export default TzolkinCharacter;
